import { createTimeInstance } from './time';

class _ApiRequestLogger {
  constructor() {
    this.prevRequests = {};
    if (window) {
      window.requestLogger = this.prevRequests;
    }
  }

  addNewRequest(id) {
    if (this.prevRequests[id]) return;

    const newRequest = {
      id,
      startTime: createTimeInstance(),
    };
    this.prevRequests[id] = newRequest;
    this.logRequest(newRequest);
  }

  markRequestEnd(id, changeId) {
    const request = this.prevRequests[id];
    if (!request) return;
    if ('endTime' in request) return;
    request.id = changeId || id;
    request.endTime = createTimeInstance();
    request.duration = this.calculateDuration(request);
    request.durationReadable = (this.calculateDuration(request) / 1000).toFixed(1) + 's';

    this.logRequest(request);
  }

  calculateDuration(request) {
    const { startTime, endTime } = request;
    return endTime.valueOf() - startTime.valueOf();
  }

  logRequest(request) {
    console.log(request.id + ':: request update', request);
  }
}

const ApiRequestLogger = new _ApiRequestLogger();
export default ApiRequestLogger;
